/* eslint-disable no-shadow */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable radix */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import moment from 'moment';
import React from 'react';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import {
  ASSIGN_STARTDATE_ERROR,
  DATE_QTR_FORMAT_ERROR,
  DATE_RANGE_INVALID,
  QUARTER_FORMAT_ERROR,
  QUARTER_VALUE_REQUIRED,
} from '../Errors/constantMessageData';
import { FROM_QTR_REQUIRED_ERR } from '../../Modules/CMS/MaintainMATDrug/Components/constantData';

export const getUserDetails = () => {
  return JSON.parse(atob(localStorage.getItem('localState')));
};

export const findUserPrev = () => {
  const userDB = getUserDetails();
  const currentUser = localStorage.getItem('logInUser');
  const currentUserPrev = userDB?.filter((v) =>
    v.username === currentUser ? v : null
  );
  return currentUserPrev.length > 0 && currentUserPrev[0];
};

export const tabHighLigther = (navTo, val) => {
  const data = JSON.parse(localStorage.getItem('tabItemsData'));
  const list = data?.map((obj) => {
    if (obj.navTo === navTo) {
      obj.isFormError = val;
    }
    return obj;
  });
  localStorage.setItem('tabItemsData', JSON.stringify(list));
};

export const removeErr = (errors, err) => {
  if (err) {
    err.forEach((val) => {
      const ind = errors.indexOf(val);
      if (ind !== -1) {
        errors.splice(ind, 1);
      }
    });
  }
  return errors;
};

export const makeFormDirty = (navTo, val) => {
  const data = JSON.parse(localStorage.getItem('tabItemsData'));
  const list = data.map((obj) => {
    if (obj.navTo === navTo) {
      obj.isFormDirty = val;
    }
    return obj;
  });
  localStorage.setItem('tabItemsData', JSON.stringify(list));
};

const errorMessage = DATE_QTR_FORMAT_ERROR;

export const qtrMapping = {
  1: 'JAN',
  2: 'APR',
  3: 'JUL',
  4: 'OCT',
};

export const qtrMappingToDate = {
  1: 'MAR',
  2: 'JUN',
  3: 'SEP',
  4: 'DEC',
};

export const qtrSortKey = (value) => {
  if (!value) return null;
  const str = String(value).trim();
  const match = str.match(/^(\d+)\s*[Qq]\s*(\d{4})$/);
  if (!match) return null;
  const qtr = Number(match[1]);
  const year = Number(match[2]);
  if (!Number.isFinite(qtr) || !Number.isFinite(year)) return null;
  return year * 10 + qtr;
};

export const qtrComparator = (valueA, valueB) => {
  const a = qtrSortKey(valueA);
  const b = qtrSortKey(valueB);
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  return a - b;
};

export const monthMapping = {
  '01': 'JAN',
  '02': 'FEB',
  '03': 'MAR',
  '04': 'APR',
  '05': 'MAY',
  '06': 'JUN',
  '07': 'JUL',
  '08': 'AUG',
  '09': 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};
export const monthMappingReverse = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAY: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OCT: '10',
  NOV: '11',
  DEC: '12',
};

// Follwoing function convert 01/01/1991 to 01-JAN-1991
export const quarterToDate = (input, type) => {
  let output = '';
  if (input?.length === 4) {
    const splitInput = input.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');

      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1]}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1]}`;
    }
  }
  if (input?.length === 6) {
    const splitInput = input.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');
      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1].substring(2)}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1].substring(2)}`;
    }
  }
  if (input?.length === 10) {
    const splitInput = input.split('/');
    output = `${splitInput[1]}-${
      monthMapping[splitInput[0]]
    }-${splitInput[2].substring(2)}`;
  }
  if (input?.length === 5) {
    const splitInput = input.split('/');
    output = `01-${monthMapping[splitInput[0]]}-${splitInput[1]}`;
  }

  if (input?.length === 7) {
    const splitInput = input.split('/');
    output = `01-${monthMapping[splitInput[0]]}-${splitInput[1].substring(2)}`;
  }
  return output;
};

// Follwoing function convert 01/01/1991 from 01-JAN-1991
export const convertStringDate = (input) => {
  let output = '';
  const splitInput = input.split('-');
  const year =
    parseInt(splitInput[2]) > 90 ? `19${splitInput[2]}` : `20${splitInput[2]}`;
  output = `${monthMappingReverse[splitInput[1]]}/${splitInput[0]}/${year}`;
  return output;
};

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateDateQuarter = (date, key) => {
  const errors = [];
  const fourDigitYearReg = /^[1-4]Q[1-9][0-9]{3}$/;
  const twoDigitYearReg = /^[1-4]Q[0-9]{2}$/;
  const allowedLength = [6, 4, 10, 7, 5];
  if (allowedLength.indexOf(date.length) !== -1) {
    if (date.length === 6) {
      if (!fourDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
    if (date.length === 4) {
      if (!twoDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }

    if (date.length === 10) {
      const dateValue = new Date(date);
      if (dateValue.toString() === 'Invalid Date' || date.indexOf('/') === -1) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }

    if (date.length === 7) {
      let splittedValue = date.split('/');
      splittedValue = `${splittedValue[0]}/01/${splittedValue[1]}`;
      if (new Date(splittedValue) === 'Invalid Date') {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
    if (date.length === 5) {
      let splittedValue = date.split('/');
      splittedValue = `${splittedValue[0]}/01/20${splittedValue[1]}`;
      if (new Date(splittedValue) === 'Invalid Date') {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
  } else {
    if (key === 'fromDate') {
      errors.push({
        field: key,
        message: errorMessage,
      });
    }
    if (key === 'toDate' && date.trim() !== '') {
      errors.push({
        field: key,
        message: errorMessage,
      });
    }
  }
  return errors;
};

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateDate = (date, key) => {
  const errors = [];
  if (date.length === 10) {
    const dateValue = new Date(date);
    if (dateValue.toString() === 'Invalid Date') {
      errors.push({
        field: key,
        message: ASSIGN_STARTDATE_ERROR,
      });
    }
  } else {
    errors.push({
      field: key,
      message: ASSIGN_STARTDATE_ERROR,
    });
  }
  return errors;
};

function convertQuarterToDate(quarter) {
  // Split the quarter string into quarter and year
  const [quarterNum, year] = quarter?.split('Q');

  // Add "20" prefix to the year if it is less than 100
  const fullYear = parseInt(year) < 91 ? `20${year}` : `19${year}`;

  // Construct the converted date format
  const convertedDate = `${quarterNum}Q${fullYear}`;

  return convertedDate;
}

export const autoFormateDate = (inputDate) => {
  const quarterReg = /^[1-4]Q[0-9]{2}$/;
  if (inputDate?.length === 4 && quarterReg.test(inputDate)) {
    return convertQuarterToDate(inputDate);
  }

  // Reject too-short inputs outright
  if (!inputDate || inputDate.length < 6) {
    return inputDate; // just return as-is, don't try to format
  }

  let month, day, year;

  if (inputDate.includes('/')) {
    const parts = inputDate.split('/');
    if (parts.length !== 3) return inputDate;
    [month, day, year] = parts;
  } else {
    month = inputDate.substring(0, 2);
    day = inputDate.substring(2, 4);
    year = inputDate.substring(4);
  }

  if (!month || !day || !year) {
    return inputDate; // invalid format
  }

  const date = new Date(`${month}/${day}/${year}`);
  if (isNaN(date.getTime())) {
    return inputDate; // invalid date
  }

  return (
    `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
    `${date.getDate().toString().padStart(2, '0')}/` +
    `${date.getFullYear()}`
  );
};

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateQuarter = (date, key, isRequired = false, filedName) => {
  const errorMessage = QUARTER_FORMAT_ERROR;
  const errors = [];
  const fourDigitYearReg = /^[1-4]Q[1-9][0-9]{3}$/;
  const twoDigitYearReg = /^[1-4]Q[0-9]{2}$/;
  const allowedLength = [6, 4];
  if (isRequired && date?.trim().length === 0) {
    errors.push({
      field: key,
      message:
        filedName === 'fromQtr'
          ? FROM_QTR_REQUIRED_ERR
          : QUARTER_VALUE_REQUIRED,
    });
  } else if (allowedLength.indexOf(date?.length) !== -1) {
    if (date.length === 6) {
      if (!fourDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
    if (date.length === 4) {
      if (!twoDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
  } else {
    errors.push({
      field: key,
      message: errorMessage,
    });
  }
  return errors;
};

export const convertToFourDigitYear = (year) => {
  const currentYear = new Date().getFullYear(); // Get the current year
  const currentCentury = Math.floor(currentYear / 100) * 100; // Get the current century

  // Convert the year to a number and add the current century
  let fourDigitYear = Number(year) + currentCentury;

  // If the calculated 4-digit year is in the future, subtract 100 years
  if (fourDigitYear > currentYear) {
    fourDigitYear -= 100;
  }

  return fourDigitYear;
};

export const compareQuarterAndYear = (q1, y1, q2, y2) => {
  // Convert quarter and year to numbers
  q1 = Number(q1);
  y1 = Number(y1);
  q2 = Number(q2);
  y2 = Number(y2);

  // Compare the years first
  if (y1 > y2) {
    return 1;
  }
  if (y1 < y2) {
    return -1;
  }

  // If years are the same, compare the quarters
  if (q1 > q2) {
    return 1;
  }
  if (q1 < q2) {
    return -1;
  }
  return 0;
};

export const getCurrentQtr = () => {
  return [moment(new Date()).quarter(), new Date().getFullYear()];
};

export const getCurrentDate = (format) => {
  return moment(new Date()).format(format);
};

// Function to match filter with and witout doller in tables
export const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

// Function to match two decimal number value even if it has 0 as last value
export const textMatcherWith2Decimal = ({
  filterOption,
  value: val,
  filterText,
}) => {
  const value = Math.abs(val)?.toFixed(2);
  const valueWithDollar = `$ ${value}`;

  if (filterText == null) {
    return false;
  }

  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar === filterText;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      return value.endsWith(filterText) || valueWithDollar.endsWith(filterText);
    default:
      return false;
  }
};
// export const amountComparator = (amount1, amount2) => {
//   let amt1 = null;
//   let amt2 = null;
//   if (amount1 && amount1?.toString()?.includes('$')) {
//     amt1 = parseFloat(
//       amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
//     );
//   } else {
//     amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
//   }
//   if (amount2 && amount2?.toString()?.includes('$')) {
//     amt2 = parseFloat(
//       amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
//     );
//   } else {
//     amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
//   }
//   if (amt1 === null && amt2 === null) {
//     return 0;
//   }
//   if (amt1 === null) {
//     return -1;
//   }
//   if (amt2 === null) {
//     return 1;
//   }

//   return amt1 - amt2;
// };

export function amountComparator(amount1, amount2) {
  const parseAmount = (val) => {
    if (!val) return null;
    const cleaned = val.toString().replace(/[^0-9.-]+/g, '');
    return parseFloat(cleaned);
  };

  const amt1 = parseAmount(amount1);
  const amt2 = parseAmount(amount2);

  if (amt1 === null && amt2 === null) return 0;
  if (amt1 === null) return -1;
  if (amt2 === null) return 1;

  return amt1 - amt2;
}

export const cellRendererWithoutDec = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';

  // Check if currency symbol '$' needs to be used
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }

  const printPostfixValue = params.colDef.printPostfixValue || '';

  // If cell value is empty, return empty
  if (cellValue === '') {
    return '';
  }

  let value = 0;

  // Handle dollar amounts (if DisplayValue includes '$')
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }

  // Handle special case for bottom row
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{
              color: '#eb0000',
              textAlign: 'right',
              display: 'inline',
              float: 'right',
            }}
          >
            (
            {`${printPrefixValue} ${Math.abs(pinnedValue).toLocaleString(
              'en-US',
              {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }
            )} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${pinnedValue?.toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} 0 ${printPostfixValue}`}</b>
      </div>
    );
  }

  // For negative values, display in red with parentheses
  if (value < 0) {
    return (
      <span
        style={{
          color: '#cc0000 ',
          textAlign: 'right',
          display: 'inline',
          float: 'right',
        }}
      >
        {` (${printPrefixValue} ${Math.abs(value).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })} ${printPostfixValue})`}
      </span>
    );
  }

  // For positive values, display normally
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>
        {`${printPrefixValue} ${value.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })} ${printPostfixValue}`}
      </div>
    );
  }

  // If the value is 0, display it as "0"
  return (
    <div style={{ textAlign: 'right' }}>
      {`${printPrefixValue} 0 ${printPostfixValue}`}
    </div>
  );
};
export const cellRenderer = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }
  const printPostfixValue = params.colDef.printPostfixValue || '';
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{
              color: '#eb0000',
              textAlign: 'right',
              display: 'inline',
              float: 'right',
            }}
          >
            (
            {`${printPrefixValue} ${Math.abs(pinnedValue).toLocaleString(
              'en-US',
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${pinnedValue?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} 0.00 ${printPostfixValue}`}</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span
        style={{
          color: '#cc0000 ',
          textAlign: 'right',
          display: 'inline',
          float: 'right',
        }}
      >
        {` (${printPrefixValue} ${Math.abs(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
        ${printPostfixValue})`}
      </span>
    );
  }
  if (value) {
    return (
      <div
        style={{ textAlign: 'right' }}
      >{`${printPrefixValue} ${value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${printPostfixValue}`}</div>
    );
  }
  return (
    <div
      style={{ textAlign: 'right' }}
    >{`${printPrefixValue} 0.00 ${printPostfixValue}`}</div>
  );
};

export const cellRendererFourDec = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }
  const printPostfixValue = params.colDef.printPostfixValue || '';
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }

  // Ensure value has 4 digits after the decimal point
  value = Number(value.toFixed(4));

  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{
              color: '#eb0000',
              textAlign: 'right',
              display: 'inline',
              float: 'right',
            }}
          >
            (
            {`${printPrefixValue} ${Math.abs(
              parseFloat(pinnedValue)
            ).toLocaleString('en-US', {
              minimumFractionDigits: 4, // Update minimumFractionDigits to 4
              maximumFractionDigits: 4, // Update maximumFractionDigits to 4
            })} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${parseFloat(pinnedValue)?.toLocaleString(
              'en-US',
              {
                minimumFractionDigits: 4, // Update minimumFractionDigits to 4
                maximumFractionDigits: 4, // Update maximumFractionDigits to 4
              }
            )} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} 0.0000 ${printPostfixValue}`}</b>{' '}
        {/* Update to 0.0000 */}
      </div>
    );
  }
  if (value < 0) {
    return (
      <span
        style={{
          color: '#eb0000',
          textAlign: 'right',
          display: 'inline',
          float: 'right',
        }}
      >
        {` (${printPrefixValue} ${Math.abs(parseFloat(value)).toLocaleString(
          'en-US',
          {
            minimumFractionDigits: 4, // Update minimumFractionDigits to 4
            maximumFractionDigits: 4, // Update maximumFractionDigits to 4
          }
        )}
        ${printPostfixValue})`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{`${printPrefixValue} ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 4, // Update minimumFractionDigits to 4
        maximumFractionDigits: 4, // Update maximumFractionDigits to 4
      })} ${printPostfixValue}`}</div>
    );
  }
  return (
    <div style={{ textAlign: 'right' }}>
      {`${printPrefixValue} 0.0000 ${printPostfixValue}`}
    </div>
  );
};
export const fourDecimalRenderer = (params, a) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#eb0000' : '',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${parseFloat(value)
          .toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};
export const cellRendererSixDec = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }
  const printPostfixValue = params.colDef.printPostfixValue || '';
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }

  // Ensure value has 4 digits after the decimal point
  value = Number(value.toFixed(6));

  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{
              color: '#eb0000',
              textAlign: 'right',
              display: 'inline',
              float: 'right',
            }}
          >
            (
            {`${printPrefixValue} ${Math.abs(
              parseFloat(pinnedValue)
            ).toLocaleString('en-US', {
              minimumFractionDigits: 6, // Update minimumFractionDigits to 6
              maximumFractionDigits: 6, // Update maximumFractionDigits to 6
            })} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${parseFloat(pinnedValue)?.toLocaleString(
              'en-US',
              {
                minimumFractionDigits: 6, // Update minimumFractionDigits to 6
                maximumFractionDigits: 6, // Update maximumFractionDigits to 6
              }
            )} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} 0.000000 ${printPostfixValue}`}</b>{' '}
        {/* Update to 0.0000 */}
      </div>
    );
  }
  if (value < 0) {
    return (
      <span
        style={{
          color: '#eb0000',
          textAlign: 'right',
          display: 'inline',
          float: 'right',
        }}
      >
        {` (${printPrefixValue} ${Math.abs(parseFloat(value)).toLocaleString(
          'en-US',
          {
            minimumFractionDigits: 6, // Update minimumFractionDigits to 6
            maximumFractionDigits: 6, // Update maximumFractionDigits to 6
          }
        )}
        ${printPostfixValue})`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{`${printPrefixValue} ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 6, // Update minimumFractionDigits to 6
        maximumFractionDigits: 6, // Update maximumFractionDigits to 6
      })} ${printPostfixValue}`}</div>
    );
  }
  return (
    <div style={{ textAlign: 'right' }}>
      {`${printPrefixValue} 0.000000 ${printPostfixValue}`}
    </div>
  );
};
export const cellRendererThreeDec = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }
  const printPostfixValue = params.colDef.printPostfixValue || '';
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }

  // Ensure value has 3 digits after the decimal point
  value = parseFloat(value.toFixed(3));

  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{
              color: '#eb0000',
              textAlign: 'right',
              display: 'inline',
              float: 'right',
            }}
          >
            (
            {`${printPrefixValue} ${Math.abs(
              parseFloat(pinnedValue)
            ).toLocaleString('en-US', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            })} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${parseFloat(pinnedValue)?.toLocaleString(
              'en-US',
              {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              }
            )} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} 0.000 ${printPostfixValue}`}</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span
        style={{
          color: '#eb0000',
          textAlign: 'right',
          display: 'inline',
          float: 'right',
        }}
      >
        {` (${printPrefixValue} ${Math.abs(parseFloat(value)).toLocaleString(
          'en-US',
          {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          }
        )}
        ${printPostfixValue})`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{`${printPrefixValue} ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })} ${printPostfixValue}`}</div>
    );
  }
  return (
    <div
      style={{ textAlign: 'right' }}
    >{`${printPrefixValue} 0.000 ${printPostfixValue}`}</div>
  );
};
export const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
export const comparatorQtrNew = (a, b) => {
  const parseQuarter = (q) => {
    const match = q.match(/^(\d)Q(\d{4})$/);
    if (!match) return 0;
    const quarterNum = parseInt(match[1], 10);
    const year = parseInt(match[2], 10);
    return year * 10 + quarterNum;
  };

  return parseQuarter(a) - parseQuarter(b);
};
export const textCustomComparator = (filter, value, filterText) => {
  const filterTextLoweCase = filterText.trim().toLowerCase();
  const valueLowerCase = value.toString().trim().toLowerCase();
  switch (filter) {
    case 'contains':
      return valueLowerCase.indexOf(filterTextLoweCase) >= 0;
    case 'notContains':
      return valueLowerCase.indexOf(filterTextLoweCase) === -1;
    case 'equals':
      return valueLowerCase === filterTextLoweCase;
    case 'notEqual':
      return valueLowerCase !== filterTextLoweCase;
    case 'startsWith':
      return valueLowerCase.indexOf(filterTextLoweCase) === 0;
    case 'endsWith':
      const index = valueLowerCase.lastIndexOf(filterTextLoweCase);
      return (
        index >= 0 &&
        index === valueLowerCase.length - filterTextLoweCase.length
      );
    default:
      return false;
  }
};
export const checkNumber = (value) => {
  return (
    (typeof value === 'number' || typeof value === 'string') && !isNaN(value)
  );
};

export const isReadOnly = (path, loginState) => {
  // const userRole = JSON.parse(localStorage.getItem('loginState'));
  const userRole = loginState;
  if (path === '/PasswordToBeExpire' || path === '/ChangePassword') {
    return { name: path };
  }
  if (userRole) {
    const childDetails = [];
    userRole.menuItems.map((arrr) => {
      if (arrr.children.length === 0) {
        if (arrr.rootUrl === path) {
          childDetails.push(arrr);
        }
      } else {
        arrr.children.map((childData) => {
          if (childData.url === path) {
            childDetails.push(childData);
          }
        });
      }
    });
    return childDetails.length > 0 ? childDetails[0] : [];
  }
};
/**
 * Looks up a menu child's readOnly flag by parent name, child name, and URL.
 * Example: checkReadOnlyAccessFc("Maintain", "Check", "/check", loginState)
 * @returns {boolean} child's readOnly value, or false if no match
 */
export const checkReadOnlyAccessFc = (
  parentName,
  childName,
  url,
  loginState
) => {
  const menuItems = loginState?.menuItems || loginState?.data || [];
  if (!Array.isArray(menuItems) || menuItems.length === 0) {
    return false;
  }

  const parent = menuItems.find((item) => item?.name === parentName);
  if (!parent?.children?.length) {
    return false;
  }

  const child = parent.children.find(
    (item) => item?.name === childName && item?.url === url
  );

  return child?.readOnly === true;
};
export const checkActionAccessByRole = (roleToCheck, kcRoles) => {
  const userState = kcRoles;
  // console.log(userState,'userState')
  const roleToCheckUpdated = roleToCheck?.split(',') ?? [];
  // console.log(roleToCheckUpdated,'roleToCheckUpdated')
  const hasAccess = !(
    userState &&
    userState.userPrivileges &&
    userState.userPrivileges.length > 0 &&
    roleToCheckUpdated.some((role) => userState.userPrivileges.includes(role))
  );
  // console.log(hasAccess,'hasAccess')
  return hasAccess;
};

export const updateHeaderArray = (arrayToCheck, kcRoles) => {
  const updatedHeaders = [...arrayToCheck];
  if (
    !checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  ) {
    // If the condition is met, remove the first column
    const filteredHeaders = updatedHeaders.filter(
      (header) => header.headerName !== 'Actions'
    );

    return filteredHeaders;
  }

  return updatedHeaders;
};
// add draggable dialog popup
export const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      // cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

// sorting for number and alphabet
export const NumberAndAlphabetComparator = (a, b) => {
  const reA = /[^a-zA-Z]/g;
  const reN = /[^0-9]/g;
  const aA = a.replace(reA, '');
  const bA = b.replace(reA, '');
  if (aA === bA) {
    const aN = parseInt(a.replace(reN, ''), 10);
    const bN = parseInt(b.replace(reN, ''), 10);
    return aN === bN ? 0 : aN > bN ? 1 : -1;
  }
  return aA > bA ? 1 : -1;
};

export const NumberAlongAlphabetComparator = (a, b) => {
  // Treat null or undefined as empty strings
  a = a || '';
  b = b || '';

  // Early return for empty values
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const reA = /[^a-zA-Z]/g;
  const reN = /[^0-9]/g;

  const aA = a?.replace(reA, '')?.toLowerCase();
  const bA = b?.replace(reA, '')?.toLowerCase();

  if (aA === bA) {
    const aN = parseInt(a?.replace(reN, ''), 10);
    const bN = parseInt(b?.replace(reN, ''), 10);

    const validA = isNaN(aN) ? -Infinity : aN;
    const validB = isNaN(bN) ? -Infinity : bN;

    return validA - validB;
  }

  return aA?.localeCompare(bA);
};

export const fromQtrToDT = (val) => {
  if (!val || typeof val !== 'string' || !val.includes('Q')) return '';
  const [qtr, year] = val.split('Q');
  switch (qtr) {
    case '1':
      return `01/01/${year}`;
    case '2':
      return `04/01/${year}`;
    case '3':
      return `07/01/${year}`;
    case '4':
      return `10/01/${year}`;
    default:
      return '';
  }
};

export const toQtrToDT = (val) => {
  if (!val || typeof val !== 'string' || !val.includes('Q')) return '';
  const [qtr, year] = val.split('Q');
  switch (qtr) {
    case '1':
      return `03/31/${year}`;
    case '2':
      return `06/30/${year}`;
    case '3':
      return `09/30/${year}`;
    case '4':
      return `12/31/${year}`;
    default:
      return '';
  }
};

export const qtrToPreviousStartDt = (dateStr) => {
  // Validate MM/DD/YYYY format using regex
  const datePattern =
    /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/;
  if (!datePattern.test(dateStr)) {
    return 'Invalid date format. Please use MM/DD/YYYY.';
  }

  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth(); // 0 (Jan) to 11 (Dec)

  // Determine the current quarter (1, 2, 3, 4)
  const currentQuarter = Math.floor(month / 3) + 1;

  // Calculate previous quarter
  let previousQuarter = currentQuarter - 1;
  let previousYear = year;

  if (previousQuarter < 1) {
    previousQuarter = 4; // Wrap to the previous year
    previousYear -= 1;
  }

  // Determine the starting month of the previous quarter
  const quarterStartMonth = (previousQuarter - 1) * 3; // 0 (Jan) to 9 (Oct)

  // Return the first day of the previous quarter
  return `${String(quarterStartMonth + 1).padStart(2, '0')}/01/${previousYear}`; // Format as MM/DD/YYYY
};

export const qtrToPreviousEndDt = (dateStr) => {
  // Validate MM/DD/YYYY format using regex
  const datePattern =
    /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/;
  if (!datePattern.test(dateStr)) {
    return 'Invalid date format. Please use MM/DD/YYYY.';
  }

  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth(); // 0 (Jan) to 11 (Dec)

  // Determine the current quarter (1, 2, 3, 4)
  const currentQuarter = Math.floor(month / 3) + 1;

  // Calculate previous quarter
  let previousQuarter = currentQuarter - 1;
  let previousYear = year;

  if (previousQuarter < 1) {
    previousQuarter = 4; // Wrap to the previous year
    previousYear -= 1;
  }

  // Determine the ending month of the previous quarter
  const quarterEndMonth = previousQuarter * 3 - 1; // 0 (Jan) to 11 (Dec)

  // Return the last day of the previous quarter
  const lastDay = new Date(previousYear, quarterEndMonth + 1, 0).getDate(); // Last day of the month
  return `${String(quarterEndMonth + 1).padStart(
    2,
    '0'
  )}/${lastDay}/${previousYear}`; // Format as MM/DD/YYYY
};
export const getColumnStateKey = ({ columnStateId, fileName, pathname }) => {
  if (columnStateId) return `aggrid:colstate:${columnStateId}`;
  const path = (pathname || window.location.pathname || '').replace(/\//g, ':');
  const name = (fileName || 'default').toString().replace(/\s+/g, '');
  return `aggrid:colstate:${path}:${name}`;
};

export const persistColumnState = (columnApi, key) => {
  try {
    const state = columnApi?.getColumnState?.();
    if (Array.isArray(state) && state.length) {
      localStorage.setItem(key, JSON.stringify(state));
    }
  } catch {
    // ignore
  }
};

// export const applySavedColumnState = (api, columnApi, key) => {
//   try {
//     const raw = localStorage.getItem(key);
//     if (!raw) return false;
//     const state = JSON.parse(raw);
//     if (Array.isArray(state) && state.length) {
//
//       setTimeout(() => {
//         columnApi.applyColumnState({ state, applyOrder: true });
//          api.refreshHeader()

//       }, 0);
//       return true;
//     }
//   } catch {
//     // ignore
//   }
//   return false;
// };

export const attachColumnStatePersistence = (api, columnApi, key) => {
  const persist = () => persistColumnState(columnApi, key);
  const events = [
    'columnMoved',
    'columnPinned',
    'columnVisible',
    'columnResized',
    'sortChanged',
    'columnRowGroupChanged',
    'columnValueChanged',
    'columnPivotChanged',
  ];
  events.forEach((evt) => api?.addEventListener?.(evt, persist));
  return () =>
    events.forEach((evt) => api?.removeEventListener?.(evt, persist));
};

const addOnce = (api, event, cb) => {
  const handler = (...args) => {
    api.removeEventListener(event, handler);
    cb(...args);
  };
  api.addEventListener(event, handler);
  return () => api.removeEventListener(event, handler);
};

const columnsReady = (columnApi) =>
  !!columnApi?.getAllGridColumns && columnApi.getAllGridColumns().length > 0;

export const applySavedColumnState = (api, columnApi, key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const state = JSON.parse(raw);
    if (!Array.isArray(state) || !state.length) return false;

    const doApply = () => {
      columnApi.applyColumnState({ state, applyOrder: true });
      api.refreshHeader();
    };

    if (columnsReady(columnApi)) {
      doApply();
      return true;
    }

    let detach1, detach2;
    const tryApplyOnce = () => {
      if (!columnsReady(columnApi)) return;
      if (detach1) detach1();
      if (detach2) detach2();
      doApply();
    };

    detach1 = addOnce(api, 'columnEverythingChanged', tryApplyOnce);
    detach2 = addOnce(api, 'firstDataRendered', tryApplyOnce);
    return true;
  } catch {
    return false;
  }
};
export const normalizeDate = (date, type = 'from') => {
  if (typeof date !== 'string') return date;
  const fourDigitYearReg = /^[1-4]Q[1-9][0-9]{3}$/;
  const twoDigitYearReg = /^[1-4]Q[0-9]{2}$/;
  const isQuarter = fourDigitYearReg.test(date) || twoDigitYearReg.test(date);
  if (!isQuarter) return date;
  const toDateFlag = type === 'to' || type === 'toDate' ? 'toDate' : undefined;
  const qtrFormatted = quarterToDate(date, toDateFlag);
  return convertStringDate(qtrFormatted);
};
export const normalizeToDate = (value, type = 'from') => {
  if (!value) return null;
  const v = value.toUpperCase().trim();
  const match = v.match(/^([1-4])Q(\d{4})$/);
  if (match) {
    const quarter = Number(match[1]);
    const year = Number(match[2]);
    const startMonths = [0, 3, 6, 9]; // Jan, Apr, Jul, Oct
    const endMonths = [2, 5, 8, 11]; // Mar, Jun, Sep, Dec
    if (type === 'from') {
      return new Date(year, startMonths[quarter - 1], 1);
    } else {
      const month = endMonths[quarter - 1];
      return new Date(year, month + 1, 0);
    }
  }
  const parsed = new Date(value);
  return isNaN(parsed) ? null : parsed;
};
const getPrivilegedCommentCorrRoles = () => {
  const restrictedRoles = (process.env.REACT_APP_NORMAL_ONLY_ROLE || '')
    .split(',')
    .map((role) => role.trim())
    .filter(Boolean);
  return (process.env.REACT_APP_COMMENTS_CORR_ROLE || '')
    .split(',')
    .map((role) => role.trim())
    .filter((role) => role && !restrictedRoles.includes(role))
    .join(',');
};

const userHasAnyRole = (rolesCsv, kcRoles) =>
  Boolean(rolesCsv) && !checkActionAccessByRole(rolesCsv, kcRoles);

export const canMutateCommentsByRole = (kcRoles) =>
  userHasAnyRole(getPrivilegedCommentCorrRoles(), kcRoles) ||
  checkActionAccessByRole(process.env.REACT_APP_NORMAL_ONLY_ROLE, kcRoles);

export const hasCommentsCorrEditAccess = (kcRoles) =>
  userHasAnyRole(getPrivilegedCommentCorrRoles(), kcRoles);